export const sampleBundle = {
  id: '1234abcd',
  version: '1.0.0',
  metadata: {
    ready: true,
    error_messages: [],
    owner: 'h8srZ4wTb9OLjw1ajmMJyfLEqti2',
    data_type: 'object_scan',
    created: '2022-10-25T08:42:45.956Z',
    server_created: '2022-10-25T08:26:13.121Z',
    size: 102575496,
    poster_jpg_data: 'dummystring=',
    poster_mask_png_data: 'dummystring=',
    thread_id: '221025_004908',
    object_scan: {
      max_coordinate: [
        0.06392896920442581, 0.07665105164051056, 0.06048416718840599,
      ],
      edit_modified: '2022-10-25T08:42:45.956Z',
      min_coordinate: [
        -0.06330688297748566, -0.07667870819568634, -0.06096441671252251,
      ],
    },
    prime_job: {
      auto_stencil: true,
    },
  },
  owner_editable: {
    shared: false,
    tombstoned: false,
    wall_mounted: false,
    details: {
      description: 'This is a wooden twin lens reflex camera model.',
      title: 'Camera Box',
      email: 'info+test@steampunk.digital',
    },
    details_public: {
      description: true,
      title: true,
      email: true,
    },
  },
  internal: {
    required: [],
  },
}

//make copy of sampleBundle
const sampleBundle2 = JSON.parse(JSON.stringify(sampleBundle))

sampleBundle2.id = '5678efgh'
sampleBundle2.owner_editable.details.title = 'wood box'

export const sampleBundles = [sampleBundle, sampleBundle2]
